import React, { Component } from "react";

import axios from "axios";
import * as Sentry from "@sentry/browser";
import { MagicSpinner } from "react-spinners-kit";
import API from "../../variablesGlobales";
import $ from "jquery";

import {
  BootstrapTable,
  TableHeaderColumn,
  ClearSearchButton,
} from "react-bootstrap-table";
import { Link, NavLink } from "react-router-dom";

import Menu from "../menu/Menu";

export default class Technologie extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      api: API.API,
      addToolInProgress: false,
      newTechnologie: {
        name: "",
      },
      technologie: [],
    };
  }
  componentDidMount() {
    this.__getTechnologie();
  }
  __getTechnologie = () => {
    axios
      .get(this.state.api + "technologies")
      .then((res) => {
        this.setState({
          loading: false,
        });
        if (res.data.success) {
          this.setState({
            technologie: res.data.data.reverse(),
          });
        }
        //console.log(this.state.tache);
      })
      .catch((error) => {
        if (process.env.NODE_ENV !== "production") {
          return;
        }
        Sentry.captureException(error);
      });
  };

  deleteTechnologie = (technologie) => {
    axios
      .delete(this.state.api + "technologies/" + technologie.id)
      .then((res) => {
        if (res.data.success) {
          this.__getTechnologie();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  actionsFormatter(cell, row) {
    return (
      <span>
        <button
          onClick={() => {
            this.deleteTechnologie(row);
          }}
          id="delete_tool"
          className="btn btn-info show-btn volkeno-red-bcolor"
        >
          <i class="fa fa-trash"></i>
        </button>
        &nbsp;&nbsp;
      </span>
    );
  }

  addTechnologie() {
    this.setState({
      addToolInProgress: true,
    });
    console.log(this.state.newTechnologie);
    axios
      .post(this.state.api + "technologies", this.state.newTechnologie)
      .then((res) => {
        if (res.data.success) {
          this.__getTechnologie();
          $(".close").click();
          this.setState({
            addToolInProgress: false,
            name: ""
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  render() {
    const options = {
      // clearSearch: true,
      clearSearchBtn: this.createCustomClearButton,
    };
    return (
      <div>
        <Menu />
        <div className="row no-content-wrapper">
          <section className="content-header">
            <h1>Liste des Technologies</h1>
            <ol class="breadcrumb">
              <li>
                <NavLink to="dashboard-admin">
                  <i class="fa fa-dashboard"></i> Home
                </NavLink>
              </li>
              <li className="active">Liste des Technologies</li>
            </ol>
          </section>
          <div className="row add_prospect_container">
            <div className="col-md-6 col-md-offset-3 add-prospect-btn-container">
              <span
                data-toggle="modal"
                className="btn btn-success add_coach_btn button button addBtn"
                data-placement="top"
                data-target="#addtechnologieModal"
              >
                <i className="fas fa-plus-circle"></i>
              </span>
            </div>
          </div>

          {/* Modal Add technologie */}

          <div
            className="modal fade"
            id="addtechnologieModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="addtechnologieModalLabel"
          >
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h4 className="modal-title" id="addtechnologieModalLabel">
                    Ajouter une technologie
                  </h4>
                </div>

                <div className="modal-body">
                  <div className="edit-bakeliste-container">
                    <div className="col-md-6">
                      <div className="form-group ">
                        <label>Nom:</label>
                        <input
                          type="text"
                          className="form-control"
                          id="inputName"
                          placeholder="Nom"
                          name="name"
                          value={this.state.name}
                          onChange={(e) => {
                            let newTechnologie = this.state;
                            newTechnologie.name = e.target.value;
                            this.setState({
                              newTechnologie,
                            });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <div className="row">
                      <div className="col-md-12">
                        <button
                          type="button"
                          className="btn btn-default cancel_btn cancel button"
                          data-dismiss="modal"
                        >
                          <i className="fas fa-times-circle"></i> &nbsp; Quitter
                        </button>
                        {!this.state.addToolInProgress ? (
                          <button
                            type="button"
                            className="btn btn-primary btn_for_assignation button addBtn"
                            onClick={(e) => this.addTechnologie(e)}
                          >
                            <i className="fas fa-undo"></i>&nbsp; Ajouter
                          </button>
                        ) : (
                          <button
                            type="button"
                            className="btn btn-warning button addBtn btn_for_wait"
                          >
                            Ajouter en cours &nbsp;
                            <i className="fas fa-spinner fa-spin"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <BootstrapTable
            data={this.state.technologie}
            striped={true}
            hover={true}
            condensed={true}
            multiColumnSort={2}
            options={options}
            pagination
            search={true}
          >
            <TableHeaderColumn dataField="id" isKey={true} hidden={true}>
              {" "}
              ID
            </TableHeaderColumn>
            <TableHeaderColumn dataField="name">Nom</TableHeaderColumn>

            <TableHeaderColumn
              dataField="id"
              dataFormat={this.actionsFormatter.bind(this)}
              dataSort={true}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    );
  }
}
